import CommandHandler from "diagram-js/lib/command/CommandHandler";
import {END_NODE_ID,} from '../../../../../../../ispm-web/shared/modules/bpmn/index';
import Selection from 'diagram-js/lib/features/selection/Selection';
import {select, Store} from "@ngrx/store";
import {selectNodeCreationInfoById} from "@ispm-client/modules/bpmn-modeler/store/selectors";
import {CopiedBpmnNodeCreatedResult} from "@ispm-client/modules/bpmn-modeler/models/copied-bpmn-node-created-result";
import {NodeCreationResult} from "@ispm-client/modules/bpmn-modeler/models/node-creation-result";
import {TreatmentPlanSelectorResult} from "@ispm-client/modules/bpmn-modeler/models/treatment-plan-selector-result";
import {State} from "@ispm-client/modules/bpmn-modeler/store/state";
import {NodeCopied, NodesClipboardReset} from "@ispm-client/modules/bpmn-modeler/store/actions";
import {take} from "rxjs/operators";
import {cloneDeep} from 'lodash';
import {ModelingUtil} from "@ispm/shared/bpmn-io/modeling-util";
import {NodeType} from "@ispm/shared/bpmn-io/node-type";
import {CurationUtils} from "../../../../app/curation/utils/curation-utils";

enum NeighborhoodNodeType {
    neighborhood_head,
    neighborhood_entry
}

export class CopyNodeHierarchyHandler implements CommandHandler {

    private isContainNeighborhood: boolean = false;

    constructor(private selection: Selection, private store$: Store<State>) {
    }


    postExecute(context): any {
        const element = context.element;
        let newSelection = [element];
        this.isContainNeighborhood = false;
        this.store$.pipe(select(selectNodeCreationInfoById(this.calculateNodeCreationInfo(element))), take(1))
            .subscribe(nodesCreationInfo => {
                if (nodesCreationInfo && nodesCreationInfo.length > 0 && nodesCreationInfo[0]) {
                    nodesCreationInfo[0].nodeType = context.element.type;

                    // if array length is 2, its contain data of neighborhood entry and neighborhood head
                    if (nodesCreationInfo.length === 2 && nodesCreationInfo[1]) {
                        // convert neighborhood head to normal node
                        const neighborhoodEntryCreationInfo = nodesCreationInfo[NeighborhoodNodeType.neighborhood_entry];
                        nodesCreationInfo[NeighborhoodNodeType.neighborhood_head] = this.calculateNeighborhoodHeadData(neighborhoodEntryCreationInfo, nodesCreationInfo[NeighborhoodNodeType.neighborhood_head]);
                    }
                    // convert head node to normal node
                    if (nodesCreationInfo[0].type === NodeType.head) {
                        nodesCreationInfo[0].type = NodeType.normal;
                    }
                    let copiedObject: CopiedBpmnNodeCreatedResult<NodeCreationResult | TreatmentPlanSelectorResult> = cloneDeep(nodesCreationInfo[0]);
                    copiedObject.data = CurationUtils.setCopyRelatedEntity(copiedObject.data);;
                    this.calculateElementHierarchy(element, element, newSelection, copiedObject);
                    this.selection.select(newSelection, true);
                    this.store$.dispatch(new NodesClipboardReset({}));
                    this.store$.dispatch(new NodeCopied({
                        clipboard: {
                            copiedObject: copiedObject,
                            isContainNeighborhood: this.isContainNeighborhood
                        }
                    }));
                }
            });
    }

    private calculateNeighborhoodHeadData(neighborhoodEntryNodeData, neighborhoodHeadNodeData) {
        neighborhoodHeadNodeData.type = NodeType.normal;
        const neighborhoodHeadID = neighborhoodHeadNodeData.data.id;
        const neighborhoodHeadName = neighborhoodHeadNodeData.data.name;
        neighborhoodHeadNodeData.data = cloneDeep(neighborhoodEntryNodeData.data);
        neighborhoodHeadNodeData.data.id = neighborhoodHeadID;
        neighborhoodHeadNodeData.data.name = neighborhoodHeadName;
        return neighborhoodHeadNodeData;
    }


    private calculateElementHierarchy(element, rootElement, newSelection, copiedObject): void {
        if (element.id !== rootElement.id) {
            newSelection.push(element);
        }
        if (ModelingUtil.getNodeType(element) === NodeType.neighborhood_entry) {
            this.isContainNeighborhood = true;
        }

        const outgoingConnections = element.outgoing;
        let target;
        for (const conn of outgoingConnections) {
            if (!ModelingUtil.hasDeletionTrackingChange(conn)) {
                target = conn.target;
                if (target.id !== END_NODE_ID && !ModelingUtil.hasDeletionTrackingChange(target)) {
                    this.store$.pipe(select(selectNodeCreationInfoById([target.id])), take(1))
                        .subscribe(data => {
                            if (data && data.length > 0 && data[0]) {
                                data[0].nodeType = target.type;
                                let child: CopiedBpmnNodeCreatedResult<NodeCreationResult | TreatmentPlanSelectorResult> = cloneDeep(data[0]);
                                child.data = CurationUtils.setCopyRelatedEntity(child.data);
                                if (!copiedObject.childrenNodes) {
                                    copiedObject.childrenNodes = [];
                                }
                                copiedObject.childrenNodes.push(child);
                                this.calculateElementHierarchy(target, rootElement, newSelection, child);
                            } else {
                                copiedObject.childrenNodes = [];
                                this.calculateElementHierarchy(target, rootElement, newSelection, copiedObject);
                            }
                        });
                }
            }
        }
    }

    private calculateNodeCreationInfo(element) {
        if (ModelingUtil.getNodeType(element) === NodeType.neighborhood_head) {
            const neighborhoodEntry = element.incoming[0].source;
            return [element.id, neighborhoodEntry.id];
        }
        return [element.id]
    }

}
